import { useState } from "react";

export const FAQAccordion = ({ items }) => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="faq-accordion">
      {items.map((item, i) => (
        <div className={"faq-item" + (openIndex === i ? " open" : "")} key={i}>
          <button
            className="faq-question"
            onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
            aria-expanded={openIndex === i}
          >
            <span>{item.q}</span>
            <span className="faq-icon">{openIndex === i ? "–" : "+"}</span>
          </button>
          {openIndex === i && <div className="faq-answer">{item.a}</div>}
        </div>
      ))}
    </div>
  );
};
